/* eslint-disable max-len */
import React from 'react'

const DashboardIcon = ({ ariaHidden }) => (
  <svg
    aria-hidden={ariaHidden}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-688.000000, -23.000000)"
        fill="#CCCCCC"
      >
        <g>
          <g
          transform="translate(688.000000, 23.000000)"
          >
            <g>
              <path
                d="M23.7294999,14.03902 C23.6344999,14.1213057 23.5169999,14.161469 23.3994999,14.161469 C23.2619999,14.161469
               23.1249999,14.1061221 23.0264999,13.9968976 L21.9064999,12.752816 L21.9064999,22.9621218 C21.9064999,23.5013871 21.4599999,23.9397545 20.9109999,23.9397545 L15.9335,23.9397545 C15.385,23.9397545 14.9385,23.5013871 14.9385,22.9621218 L14.9385,15.6284077 L8.45299998,15.6122445 L8.45299998,22.9591831 C8.45299998,23.4984483 8.02149998,23.9397545 7.47249998,23.9397545 L2.99299999,23.9397545 C2.44399999,23.9397545 1.95299999,23.4984483 1.95299999,22.9591831 L1.95299999,12.8022854 L0.877499998,13.9968976 C0.695499998,14.1982037 0.380999999,14.2182853 0.1745,14.03902 C-0.0309999998,13.8602445 -0.0504999997,13.5511833 0.132,13.3488976 L11.579,0.637224475 C11.7685,0.427591827 12.1355,0.427591827 12.325,0.637224475 L21.7509999,11.1046528 C21.7589999,11.1119997 21.7649999,11.1203262 21.7724999,11.128163 L23.7724999,13.3488976 C23.9544999,13.5511833 23.9349999,13.8602445 23.7294999,14.03902 Z M11.9519999,1.69910207 L2.95299994,11.6919187 C2.95299994,11.6924085 2.95299994,11.6933881 2.95299994,11.6938779 L2.95299994,22.9591843 L7.47249994,22.9621231 L7.47249994,15.6284086 C7.47249994,15.0891433 7.91899994,14.6507759 8.46799994,14.6507759 L14.9384999,14.6507759 C15.4874999,14.6507759 15.9334999,15.0891433 15.9334999,15.6284086 L15.9334999,22.9621231 L20.9529999,22.9591843 L20.9529999,11.6938779 L11.9519999,1.69910207 Z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default DashboardIcon
